import { createContext, useContext } from 'react'

import { cn, LoadingSpinner } from "twyne-new.ui"

const ReportLoadingContext = createContext(false)

function ReportEmpty({ children }) {
  const loading = useContext(ReportLoadingContext)

  return loading ? null : children
}

function ReportBody({ children, className = '', contentClassName = '', hasSummaryCards = false, loading = false }) {
  const wrapperClassName = cn(
    'relative p-2 twy-bg-base h-[calc(100vh-7.5rem)]',
    hasSummaryCards ? 'h-[calc(100vh-13.75rem)]! py-0!' : '',
    'max-md:flex-1 max-md:min-h-0 max-md:h-auto!',
    className,
  )

  const contentWrapperClassName = cn(
    'twy-bg-base-accent shadow rounded h-full max-h-[calc(100vh-7.5rem)] overflow-y-auto max-md:max-h-none',
    loading && 'opacity-50',
    contentClassName,
  )

  return <div className='w-full h-full twy-bg-base max-md:flex max-md:flex-col max-md:flex-1 max-md:min-h-0 max-md:h-auto'>
    <div className={wrapperClassName}>
      {loading && <div className='absolute top-20 left-0 right-0 z-40 flex justify-center pointer-events-none'>
        <LoadingSpinner />
      </div>}
      <div className={contentWrapperClassName}>
        <ReportLoadingContext.Provider value={loading}>
          {children}
        </ReportLoadingContext.Provider>
      </div>
    </div>
  </div>
}

export { ReportBody, ReportEmpty }
